import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Leads and Activity now live inside the Deal Tracker as tabs — one sales
 * workflow, one nav button. This route stays so old links keep working.
 */
export const Route = createFileRoute("/_authenticated/marketing")({
  beforeLoad: () => {
    throw redirect({ to: "/pipeline" });
  },
  component: () => null,
});
